<app-nav></app-nav>
<!-- <section class="insurances-panel">
  <div class="container">
    <div class="col">
        <div *ngIf="insuranceDetails == ''">
            <div class="panel panel-default">
              <div class="panel-heading">
                &nbsp;
              </div>
              <div class="panel-body">
                <div class="col-12">
                  <div class="row">
                    <label> No Data Found</label>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="panel panel-default"  *ngFor="let detail of insuranceDetails">
          <div class="panel-heading text-right insuranceCardEdit">
            <div class="editDots" routerLink="/editInsuranceDetails/{{detail._id}}">
              <i class="fas fa-circle text-white"></i><i class="fas fa-circle text-white"></i><i class="fas fa-circle text-white"></i>
            </div>
          </div>
          <div class="panel-body">
                <span *ngIf="detail.linkedToCard">
                    <div class="col-12 bg-panel-body">
                      <div class="row" *ngFor="let fieldDetails of detail.dynamic_fields">
                          <div class="col-4 textWrap">{{fieldDetails.name}} </div>
                          <div class="col-8 overText"><b>{{fieldDetails.value}}</b></div>
                      </div>
                    </div>
                </span>

                <span *ngIf="!detail.linkedToCard">
                  <div class="col-12 ">
                      <div class="row" *ngFor="let fieldDetails of detail.fields">
                          <div class="col-4 textWrap">{{transformName(fieldDetails.id)}} </div>
                          <div class="col-8 overText"><b>{{fieldDetails.value}}</b></div>
                      </div>
                  </div>
                </span>
                <div class="col-12">
              
                  <div class="row">
                      <div class="col-4 textWrap">Policy Type: </div>
                      <div class="col-8 overText"><b>{{detail.managerPolicyType}}</b></div>
                  </div>
              </div>
          </div>
        </div>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
      <div class="spinnerfull">
          <i class="fa fa-spinner fa-spin fa-3x"></i>
      </div>
  </div>
</section> -->

<section class="insurances-panel">
  <div class="container px-2">
    <div class="col" *ngIf="cardVisibility">
      <div class="policy-tabs">
        <ul>
          <li (click)="personalTab = true; EBTab=false; NonEBTab=false; NotifyPolicyTab= false; viewPolicyButton=false;"
            [ngClass]="{'active' : personalTab}">Personal Policies</li>
          <li (click)="EBTab = true; personalTab=false; NonEBTab=false; NotifyPolicyTab= false; viewPolicyButton=false;"
            [ngClass]="{'active' : EBTab}">EB Corporate Policies</li>
          <li (click)="NonEBTab = true; NotifyPolicyTab=false; EBTab = false; personalTab=false; viewPolicyButton=false;"
            [ngClass]="{'active' : NonEBTab}">Non EB Corporate Policies</li>
          <li (click)="NotifyPolicyTab = true; personalTab = false; EBTab=false; NonEBTab=false; viewPolicyButton=false;"
            [ngClass]="{'active' : NotifyPolicyTab}">Self Uploaded Policy</li>
            <li (click)="NotifyPolicyTab = false; personalTab = false; EBTab=false; NonEBTab=false; viewPolicyButton=false; redirectionToPam();" [ngClass]="{'active' : viewPolicyButton}">Transaction View</li>
        </ul>
      </div>
      <div *ngIf="personalTab">
        <h6 class="policy-heading pt-3">Personal Policies</h6>
        <div class="row">
          <ng-container *ngIf="personalPolicies.length > 0">
            <div class="policy-content border px-3 py-2 mb-2 mt-4 mr-3 ml-3 col-md-5 pt-2"
              *ngFor="let detail of personalPolicies; let i = index">
              <span>
                <div class="row mt-2">
                  <h4 class="policyName ml-3 mr-2  mb-4">{{detail.policyName}}</h4>
                  <img class="insurerLogo mb-3" src="{{detail.insurerLogo}}" alt="">
                </div>
                <!-- <div class="d-flex justify-content-between mb-3">
                  <span class="policy-name">{{detail.PolicyName}}</span> 
                  <span class="icon-clock"></span>
                </div> -->
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Policy No</span>
                    <span class="insured-amount pb-2">{{detail.policyNumber  ? detail.policyNumber  : 'NA'}}</span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Policy Type</span>
                    <span class="insured-amount pb-2">{{detail.userPolicyType ? detail.userPolicyType : 'NA'}}</span>
                  </div>
                  <!-- <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Email</span>
                    <span class="insured-amount pb-2">{{detail.email ? detail.email : 'NA'}}</span>
                  </div> -->
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Premium Paid</span>
                    <span class="insured-amount pb-2">{{detail.premiumPaid ? 'Rs. '+detail.premiumPaid : 'NA'}}</span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Sum Insured</span>
                    <span class="insured-amount pb-2">{{detail.sumInsured ? 'Rs. '+detail.sumInsured : 'NA'}}</span>
                  </div>
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Start Date</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyStartDate | date)  ? (detail.policyStartDate | date)  : 'NA'}}</span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">End Date</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyEndDate | date)  ? (detail.policyEndDate | date)  : 'NA'}}</span>
                  </div>
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Policy Holder Name</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyHolder )  ? (detail.policyHolder)  : 'NA'}}</span>
                  </div>
                  <!-- <div class="col-6 p-0">
                    <span class="insurer-description pb-2">End Date</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyEndDate | date)  ? (detail.policyEndDate | date)  : 'NA'}}</span>
                  </div> -->
                </div>
              </span>
              <div class="col-12 text-center mt-4">
                <button type="button" class="btn-bordered-blue" routerLink="/yourPolicyDetails"
                  (click)="getPolicyNumber(detail.id, detail.policyNumber , 'Individual')">
                  View Details
                </button>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="personalPolicies.length === 0">
            <p class="not-found">No Policy found.</p>
          </ng-container>
        </div>
      </div>
      <div *ngIf="EBTab">
        <h6 class="policy-heading pt-3">EB Corporate Policies</h6>
        <div class="row">
          <ng-container *ngIf="corporateEBPolicies.length > 0">
            <div class="policy-content border px-3 py-2 mb-2 mt-4 mr-3 ml-3  col-md-5 pt-2"
              *ngFor="let detail of corporateEBPolicies; let i = index">
              <span>
                <div class="row mt-2">
                  <h4 class="policyName ml-3 mr-2  mb-4">{{detail.policyName}}</h4>
                  <img class="insurerLogo ml-2 mb-6" src="{{detail.insurerLogo}}" alt="">
                </div>
                <!-- <div class="d-flex justify-content-between mb-3">
                  <span class="policy-name">{{detail.PolicyName}}</span>
                  <span class="icon-clock"></span>
                </div> -->
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Policy No</span>
                    <span class="insured-amount pb-2">{{detail.policyNumber ? detail.policyNumber : 'NA'}}</span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Policy Type</span>
                    <span class="insured-amount pb-2">{{detail.userPolicyType ? detail.userPolicyType : 'NA'}}</span>
                  </div>
                  <!-- <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Email</span>
                    <span class="insured-amount pb-2">{{detail.email ? detail.email : 'NA'}}</span>
                  </div> -->
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Premium Paid</span>
                    <span class="insured-amount pb-2">{{detail.premiumPaid ? 'Rs. '+detail.premiumPaid : 'NA'}}</span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Sum Insured</span>
                    <span class="insured-amount pb-2">{{detail.sumInsured ? 'Rs. '+detail.sumInsured : 'NA'}}</span>
                  </div>
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Start Date</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyStartDate | date)  ? (detail.policyStartDate | date)  : 'NA'}}</span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">End Date</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyEndDate | date)  ? (detail.policyEndDate | date)  : 'NA'}}</span>
                  </div>
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Policy Holder Name</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyHolder )  ? (detail.policyHolder)  : 'NA'}}</span>
                  </div>
                  <!-- <div class="col-6 p-0">
                    <span class="insurer-description pb-2">End Date</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyEndDate | date)  ? (detail.policyEndDate | date)  : 'NA'}}</span>
                  </div> -->
                </div>
              </span>
              <div class="col-12 text-center mt-4">
                <button type="button" class="btn-bordered-blue" routerLink="/yourPolicyDetails"
                  [queryParams]="{ eb: 'true'}" (click)="getPolicyNumber(detail.id, detail.policyNumber, 'pamPolicy')">
                  View Details
                </button>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="corporateEBPolicies.length === 0">
            <p class="not-found">No Policy found.</p>
          </ng-container>
        </div>
      </div>
      <div *ngIf="NonEBTab">
        <h6 class="policy-heading pt-3">Non EB Corporate Policies</h6>
        <div class="row">
          <ng-container *ngIf="corporateNonEBPolicies.length > 0">
            <div class="policy-content border px-3 py-2 mb-2 mt-4 mr-3 ml-3  col-md-5 pt-2"
              *ngFor="let detail of corporateNonEBPolicies; let i = index">
              <span>
                <div class="row mt-2">
                  <h4 class="policyName ml-3 mr-2  mb-4">{{detail.policyName}}</h4>
                  <img class="insurerLogo ml-2 mb-6" src="{{detail.insurerLogo}}" alt="">
                </div>
                <!-- <div class="d-flex justify-content-between mb-3">
                <span class="policy-name">{{detail.PolicyName}}</span>
                <span class="icon-clock"></span>
              </div> -->
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Policy No</span>
                    <span class="insured-amount pb-2">{{detail.policyNumber ? detail.policyNumber : 'NA'}}</span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Policy Type</span>
                    <span class="insured-amount pb-2">{{detail.userPolicyType ? detail.userPolicyType : 'NA'}}</span>
                  </div>
                  <!-- <div class="col-6 p-0">
                  <span class="insurer-description pb-2">Email</span>
                  <span class="insured-amount pb-2">{{detail.email ? detail.email : 'NA'}}</span>
                </div> -->
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Premium Paid</span>
                    <span class="insured-amount pb-2">{{detail.premiumPaid ? 'Rs. '+detail.premiumPaid : 'NA'}}</span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Sum Insured</span>
                    <span class="insured-amount pb-2">{{detail.sumInsured ? 'Rs. '+detail.sumInsured : 'NA'}}</span>
                  </div>
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Start Date</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyStartDate | date)  ? (detail.policyStartDate | date)  : 'NA'}}</span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">End Date</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyEndDate | date)  ? (detail.policyEndDate | date)  : 'NA'}}</span>
                  </div>
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Policy Holder Name</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyHolder )  ? (detail.policyHolder)  : 'NA'}}</span>
                  </div>
                  <!-- <div class="col-6 p-0">
                    <span class="insurer-description pb-2">End Date</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyEndDate | date)  ? (detail.policyEndDate | date)  : 'NA'}}</span>
                  </div> -->
                </div>
              </span>
              <div class="col-12 text-center mt-4">
                <button type="button" class="btn-bordered-blue" routerLink="/yourPolicyDetails"
                (click)="getPolicyNumber(detail.id, detail.policyNumber, 'NonEB')">
                  View Details
                </button>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="corporateNonEBPolicies.length === 0">
            <p class="not-found">No Policy found.</p>
          </ng-container>
        </div>
      </div>
      <div *ngIf="NotifyPolicyTab">
        <h6 class="policy-heading pt-3">Self Uploaded Policy</h6>
        <div class="row">
          <ng-container *ngIf="alertPolicies.length > 0">
            <div class="policy-content border px-3 py-2 mb-2 mt-4 mr-3 ml-3 col-md-5 pt-2"
              *ngFor="let detail of alertPolicies; let i = index">
              <span>
                <div class="row mt-2 d-flex align-items-space-between">
                  <h4 class="policyName col-6 mb-2">{{detail.productName}}</h4>
                  <img class="insurerLogo col-6 mb-2" src="{{detail.insurerLogo}}" alt="">
                </div>
                <!-- <div class="d-flex justify-content-between mb-3">
                <span class="policy-name">{{detail.PolicyName}}</span>
              </div> -->
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Policy No</span>
                    <span class="insured-amount pb-2">{{detail.policyNumber ? detail.policyNumber : 'NA'}}</span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Policy Holder Name</span>
                    <span class="insured-amount pb-2">{{detail.policyHolder ? detail.policyHolder : 'NA'}}</span>
                  </div>
                  <!-- <div class="col-6 p-0">
                  <span class="insurer-description pb-2">Email</span>
                  <span class="insured-amount pb-2">{{detail.email ? detail.email : 'NA'}}</span>
                </div> -->
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Premium Paid</span>
                    <span class="insured-amount pb-2">{{detail.premiumPaid ? 'Rs. '+detail.premiumPaid : 'NA'}}</span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Sum Insured</span>
                    <span class="insured-amount pb-2">{{detail.sumInsured ? 'Rs. '+detail.sumInsured : 'NA'}}</span>
                  </div>
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Start Date</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyStartDate | date)  ? (detail.policyStartDate | date)  : 'NA'}}</span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">End Date</span>
                    <span
                      class="insured-amount pb-2">{{(detail.policyEndDate | date)  ? (detail.policyEndDate | date)  : 'NA'}}</span>
                  </div>
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-6 p-0">
                    <span class="insurer-description pb-2">Policy Type</span>
                    <span class="insured-amount pb-2">{{detail.userPolicyType ? detail.userPolicyType : 'NA'}}</span>
                  </div>
                </div>
              </span>
              <div class="col-12 text-center mt-4">
                <button type="button" class="btn-bordered-blue" routerLink="/yourPolicyDetails"
                  (click)="getPolicyNumber(detail._id, detail.policyNumber,'policyAlert')">
                  View Details
                </button>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="alertPolicies.length === 0">
            <p class="not-found">No Policy found.</p>
          </ng-container>
        </div>
      </div>
      <!-- <div class="policy-content border rounded px-3 py-2 mb-2" *ngFor="let data of insuranceDetails | slice: 0:sliceCard">
        <ng-container *ngFor="let insData of data.dynamicFields">
          <div [ngClass]="{'disabled-card': convertIntoTimestamp(insData['End Date']) < newDate}">
            <div class="d-flex justify-content-between">
              <span class="policy-name">{{insData.Product}}</span>
               <span class="icon-clock"></span>
            </div>
            <div class="row m-0">
              <div class="col-6 p-0">
                <span class="insurer-detail py-2">Insurer : {{insData.Insurer}}</span>
              </div>
              <div class="col-6 p-0">
                <span class="insurer-detail py-2">Expiry Date : {{insData['End Date']}}</span>
              </div>
            </div>
            <div class="row m-0">
              <div class="col-6 p-0">
                <span class="insurer-description pb-2">Sum Insured</span>
                <span class="insured-amounts pb-2">N/A</span>
              </div>
              <div class="col-6 p-0">
                <span class="insurer-description pb-2">Premium Paid</span>
                <span class="insured-amount pb-2">Rs. {{insData.Premium}}</span>
              </div>
            </div>
          </div>
          <div class="text-center my-3">
            <button class="btn see-all-btn" (click)="seeAllCards()">See All</button>
          </div>
        </ng-container>
      </div> -->


      <!-- <div class="p-3 border rounded mb-2 tab-btn" routerLink="/insurances">
        <span class="icon icon-card"></span><span>E-Cards</span>
      </div>
      <div class="p-3 border rounded mb-2 tab-btn" routerLink="/hospitalLocator">
        <span class="icon icon-hospital"></span><span>Hospital Locator</span>
      </div>
      <div class="p-3 border rounded mb-2 tab-btn" routerLink="/addInsurance">
        <span class="icon icon-add-policy"></span><span>Add Policy</span>
      </div> -->
    </div>
    <div class="col text-center no-found" *ngIf="!cardVisibility && noDataFound">
      <label class="oops-text">Ooops....!</label>
      <img
        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/no-data-found.jpg">
      <p>No data found.</p>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>